// STERILIX — özel ürün sayfası JS
(function () {
  'use strict';

  // Kendi scroll-reveal gözlemcimiz (.strlx-reveal) — amara.js'in
  // .amara-reveal gözlemcisine bağlı değil (o seçici bu elemanlarla hiç
  // eşleşmiyordu ve sayfa tamamen görünmez kalıyordu). Güvenli tasarım:
  // CSS varsayılanı görünür, sadece bu observer gerçekten çalıştığında
  // gizlenip sonra belirir.
  function initStrlxReveal() {
    var items = document.querySelectorAll('.strlx-reveal');
    if (!items.length) return;
    items.forEach(function (el) { el.classList.add('strlx-pending'); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    items.forEach(function (el) { io.observe(el); });
  }

  function initStatCounters() {
    var stats = document.querySelectorAll('[data-strlx-count]');
    if (!stats.length) return;
    var done = new WeakSet();

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || done.has(entry.target)) return;
        done.add(entry.target);
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-strlx-count'));
        var suffix = el.getAttribute('data-strlx-suffix') || '';
        var decimals = el.getAttribute('data-strlx-decimals') ? parseInt(el.getAttribute('data-strlx-decimals'), 10) : 0;
        var duration = 1400;
        var start = null;

        function step(ts) {
          if (start === null) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var value = target * eased;
          el.textContent = value.toFixed(decimals) + suffix;
          if (progress < 1) requestAnimationFrame(step);
          else el.textContent = target.toFixed(decimals) + suffix;
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });

    stats.forEach(function (el) { io.observe(el); });
  }

  function initHeroTilt() {
    var wrap = document.querySelector('[data-strlx-tilt]');
    var img = wrap && wrap.querySelector('img');
    if (!wrap || !img) return;
    if (window.matchMedia('(hover: none)').matches) return;

    wrap.addEventListener('mousemove', function (e) {
      var rect = wrap.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      img.style.transform = 'scale(1.04) rotateX(' + (y * -6) + 'deg) rotateY(' + (x * 8) + 'deg)';
    });
    wrap.addEventListener('mouseleave', function () {
      img.style.transform = '';
    });
  }

  function initFaq() {
    document.querySelectorAll('[data-strlx-faq-item]').forEach(function (item) {
      var btn = item.querySelector('[data-strlx-faq-btn]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');
        item.closest('[data-strlx-faq]').querySelectorAll('[data-strlx-faq-item]').forEach(function (i) {
          i.classList.remove('is-open');
        });
        if (!wasOpen) item.classList.add('is-open');
      });
    });
  }

  function initStickyBar() {
    var bar = document.querySelector('[data-strlx-stickybar]');
    var trigger = document.querySelector('[data-strlx-cta-anchor]');
    if (!bar || !trigger) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(trigger);

    var stickyBtn = bar.querySelector('[data-strlx-sticky-add]');
    var mainForm = document.querySelector('[data-amara-add-to-cart]');
    if (stickyBtn && mainForm) {
      stickyBtn.addEventListener('click', function () {
        trigger.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

  function initReviewsMarqueePause() {
    var track = document.querySelector('[data-strlx-reviews-track]');
    if (!track) return;
    track.addEventListener('mouseenter', function () { track.style.animationPlayState = 'paused'; });
    track.addEventListener('mouseleave', function () { track.style.animationPlayState = 'running'; });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initStrlxReveal();
    initStatCounters();
    initHeroTilt();
    initFaq();
    initStickyBar();
    initReviewsMarqueePause();
  });
})();
